export const fetchDetail = async (api, searchParams) => {
  // console.log("fetchDtail searchParams: ", searchParams);
  try {
    let resp = await fetch(
      api.info.url.replace("{" + api.key + "}", searchParams),
      {
        method: "GET",
        headers: api.headers,
      }
    );
    // console.log("fetchDetail resp.ok", resp);
    if (resp.ok) return await resp.json();
    else return false;
  } catch (err) {
    throw err;
  }
};

export const fetchList = async (api, searchParams) => {
  // await console.log("fetchList searchParams: ", searchParams);
  try {
    let resp = await fetch(api.search.url, {
      method: "POST",
      body: JSON.stringify(searchParams ? searchParams : api.search.params),
      headers: api.headers,
    });
    // console.log("fetchList resp.ok", resp.ok);
    if (resp.ok) return await resp.json();
    else return false;
  } catch (err) {
    throw err;
  }
};

export const fetchCreate = async (api, data) => {
  // console.log("create:", { ...api.create.params, ...data });
  try {
    let resp = await fetch(api.create.url, {
      method: "POST",
      body: JSON.stringify({ ...api.create.params, ...data }),
      headers: api.headers,
    });
    // console.log("handleCreate resp.ok", resp.ok);
    if (resp.ok) return await resp.json();
    else return false;
  } catch (err) {
    throw err;
  }
};

export const fetchDelete = async (api, data) => {
  // console.log("delete:", data, api.key, data[api.key]);
  try {
    let resp = await fetch(
      api.delete.url.replace("{" + api.key + "}", data[api.key]),
      {
        method: "DELETE",
        headers: api.headers,
      }
    );
    // console.log("handleDelete resp.ok", resp.ok);
    if (resp.ok) return await resp.json();
    else return false;
  } catch (err) {
    throw err;
  }
};

export const fetchUpdate = async (api, data) => {
  // console.log("update:", data, api.update.url, api.key, api.update.params);
  try {
    let resp = await fetch(
      api.update.url.replace("{" + api.key + "}", data[api.key]),
      {
        method: "POST",
        body: JSON.stringify({ ...api.update.params, ...data }),
        headers: api.headers,
      }
    );
    // console.log("handleUpdate resp.ok", resp.ok);
    if (resp.ok) return await resp.json();
    else return false;
  } catch (err) {
    throw err;
  }
};

export const fetchPost = async (url, params, headers) => {
  try {
    let resp = await fetch(url, {
      method: "POST",
      body: JSON.stringify(params),
      headers: headers,
    });
    if (resp.ok) return await resp.json();
    else return false;
  } catch (err) {
    throw err;
  }
};

export const fetchGet = async (url) => {
  try {
    let resp = await fetch(url);
    if (resp.ok) return await resp.json();
    else return false;
  } catch (err) {
    throw err;
  }
};
const Utils = {
  fetchCreate,
  fetchDelete,
  fetchUpdate,
  fetchList,
  fetchDetail,
  fetchPost,
  fetchGet,
};

export default Utils;
